import React from 'react';
import type { CellRenderProps } from '@axiom/ui';
import { Badge } from '@axiom/ui';

import type { CandidateDetail } from '../../api/chat-api';
import { MatchGridUtil } from '../../utils/match-grid-util';

/** A flagged candidate, as the badge the rest of AHQ shows for one. */
export const MatchGridTalentFlag = ({
  data,
}: CellRenderProps<CandidateDetail>) => {
  if (!data.isFlagged) return MatchGridUtil.NOT_YET;

  return (
    <Badge background="red" name={`TALENT_FLAG_BADGE_${data.id}`}>
      Flagged
    </Badge>
  );
};
